import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider, RequireAuth } from "@/lib/auth";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Info from "@/pages/Info";
import Gallery from "@/pages/Gallery";
import Accommodations from "@/pages/Accommodations";
import Directions from "@/pages/Directions";
import Members from "@/pages/Members";
import Admin from "@/pages/Admin";
import Anleitung from "@/pages/Anleitung";
import { Communication, Guestbook } from "@/pages/Posts";
import Excursions from "@/pages/Excursions";
import Tournaments from "@/pages/Tournaments";
import Abrechnung from "@/pages/Abrechnung";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors closeButton />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              element={
                <RequireAuth>
                  <Layout />
                </RequireAuth>
              }
            >
              <Route path="/" element={<Info />} />
              <Route path="/galerie" element={<Gallery />} />
              <Route path="/uebernachtung" element={<Accommodations />} />
              <Route path="/anfahrt" element={<Directions />} />
              <Route path="/ausflugsziele" element={<Excursions />} />
              <Route path="/mitglieder" element={<Members />} />
              <Route path="/turniere" element={<Tournaments />} />
              <Route path="/abrechnung" element={<Abrechnung />} />
              <Route path="/kommunikation" element={<Communication />} />
              <Route path="/gaestebuch" element={<Guestbook />} />
              <Route path="/anleitung" element={<Anleitung />} />
              <Route
                path="/admin"
                element={
                  <RequireAuth adminOnly>
                    <Admin />
                  </RequireAuth>
                }
              />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
